<template>
    <div class="booking-view">
        <!-- Loading state -->
        <loading-state v-if="loading" fullscreen></loading-state>

        <template v-if="!loading">
            <!-- Progress Bar -->
            <progress-bar></progress-bar>

            <div class="store-banner" v-if="isBookingInStore">
                <p class="text-sm text-center m-1">
                    You're logged in at: {{ store.code }} - {{ store.name }}
                </p>
            </div>

            <side-basket></side-basket>

            <!-- Content -->
            <transition
                    name="fade"
                    mode="out-in">
                <router-view></router-view>
            </transition>

        </template>
        <page-footer></page-footer>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        beforeCreate: function() {
            document.body.className = 'home';
        },

        data() {
            return {
                loading: true
            }
        },

        mounted() {
            this.checkBooking();

            window.addEventListener('load', () => {
                this.loading = false
            });

            setTimeout(() => {
                this.loading = false
            }, 2000);
        },

        computed: {
            ...mapGetters([
                'carrier',
                'carrierDetails',
                'isBookingInStore',
                'store'
            ])
        },

        watch: {
            '$route' (to) {
                if (to.meta.title) {
                    if (process.env.VUE_APP_PARTNER_BUSINESS_NAME) {
                        document.title = to.meta.title + ' - ' + process.env.VUE_APP_PARTNER_BUSINESS_NAME
                    } else {
                        document.title = to.meta.title + ' - ' + process.env.VUE_APP_PARTNER_NAME
                    }
                }
            }
        },

        methods: {
            ...mapActions(['checkBooking'])
        }
    }
</script>

<style>
.fade-enter-active,
.fade-leave-active {
	transition-duration: 0.3s;
	transition-property: opacity;
	transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0
}

/* IE11 */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
	.fade-enter-active,
	.fade-leave-active,
	.fade-enter {
		opacity: 1;
		transition: none;
	}
}
</style>